export default __webpack_public_path__ + "static/assets/med_pill_elipse_out_L0_solid_x_01_f_mask.6c23e0c6.png";